<template>
    <div class="animated fadeIn" v-if="bot_phrase">
        <b-card>
            <h3>Фраза: "{{bot_phrase.text}}"</h3>

            <template  v-if="bot_categories.length">
                <b-form-group v-for="category in bot_categories" :key="category.id">
                    <b-check-group>
                        <b-checkbox :value="category.id" v-model="categories">
                            {{ category.name }}
                        </b-checkbox>
                    </b-check-group>
                </b-form-group>
            </template>

            <button class="btn btn-success" @click="onSave">Сохранить</button>

        </b-card>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { functions } from '@/functions.js';
    import { functions_botphrase } from '@/functions_botphrase.js';
    import {CONSTANTS} from '@/constants';

    export default {
        name: 'NsbAdminBotPhrases',
        mixins: [functions, functions_botphrase],
        data: function () {
            return {
                categories:[],
            }
        },
        methods: {
            onSave: function () {
                this.saveBotPhrase(this.categories);
            }
        },
        computed: {

        },
        created: function() {
            this.loadBotCategories();
            this.getNextBotPhrase();
        }
    }
</script>
